module.exports = __webpack_public_path__ + "img/title-bg.ad872280.png";